import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-envios-extranjero',
  templateUrl: './envios-extranjero.component.html',
  styleUrls: ['./envios-extranjero.component.css']
})
export class EnviosExtranjeroComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
